/* eslint-disable */
import { createApp } from 'vue'
import Root from '@/Root.vue'
const app = createApp(Root)
//------------------------------------------------ cookies
import VueCookies from 'vue3-cookies';
app.use(VueCookies);
//------------------------------------------------ Store
import store from "@/middlewares/store";
app.use(store);
//------------------------------------------------ service
import service from '@/middlewares/service';
app.config.globalProperties.$service = service;
//------------------------------------------------ Router
import router from "@/middlewares/router";
app.use(router);
//------------------------------------------------ Toast
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';
app.config.globalProperties.$toast = (msg, type='error')=>{
    useToast().open({message: msg, type: type, position: 'top-right'});
}
//------------------------------------------------ loading-overlay
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
app.component("loading-overlay", Loading);
//------------------------------------------------ Bootstrap
import "jquery/dist/jquery.min.js";
window.$ = window.jQuery = require('jquery')

import "@/assets/bootstrap-icons-1.11.3.min.css";
import "@/assets/bootstrap-5.3.3.min.css";
import "@/assets/select2-bootstrap-5-theme.min.css";
window.$bootstrap = require('bootstrap');
// import "bootstrap/dist/js/bootstrap.js";
// import "bootstrap"
// import "@/assets/jquery-3.7.1.min.js";
// window.bootstrap = bootstrap
// import "bootstrap-icons/font/bootstrap-icons.css";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { Modal } from 'bootstrap'
// import "bootstrap"
// import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";
//------------------------------------------------ Menu
import Menu from '@/components/Menu.vue';
app.component("Menu", Menu);
//------------------------------------------------ LoadingDots
import LoadingRow from '@/components/LoadingRow.vue';
app.component("LoadingRow", LoadingRow);
//------------------------------------------------ Barcode
// import Barcode from '@/components/Barcode.vue';
// app.component("Barcode", Barcode);
//------------------------------------------------ multiselect
import Multiselect from 'vue-multiselect'
app.component('Multiselect', Multiselect)
import 'vue-multiselect/dist/vue-multiselect.min.css';
//------------------------------------------------ Select2
import Select2 from 'vue3-select2-component';
app.component('Select2', Select2)
//------------------------------------------------ Vue3Barcode
// import Vue3Barcode from 'vue3-barcode'
// app.component('Vue3Barcode', Vue3Barcode)
//------------------------------------------------ Confirm
import Vue3ConfirmDialog from '@zapadale/vue3-confirm-dialog'
app.use(Vue3ConfirmDialog);
//------------------------------------------------ vue3-print
import print from 'vue3-print-nb'
app.use(print);
//------------------------------------------------ vue-sweetalert2
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
app.use(VueSweetalert2);
//------------------------------------------------ html2pdf
// import VueHtml2pdf from 'vue3-html2pdf'
// Vue.use(VueHtml2pdf)
//------------------------------------------------ 
// Vue.mixin({
//     methods: {
//         formatMoney(value) {
//             return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//         },
//         formatMoney2(value) {
//             return (!value | value == 0) ? 0 : parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//         },
//     }
// });
app.config.globalProperties.formatMoney = (value)=>{
    if(!value) return '0.00';
    if(typeof(value) == 'string' && !isNaN(value)) value = parseInt(value);
    return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
app.config.globalProperties.$round2 = (value)=>{
    if(!value) return 0;
    return Math.round((value + Number.EPSILON) * 100) / 100
}
app.config.globalProperties.formatThousand = (value)=>{
    if(!value) return '--';
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
app.config.globalProperties.$getMonthStart = ()=>{
    var today = new Date();
    var date = new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0, 0);
    date = new Date(date.getTime() - (date.getTimezoneOffset() * 60 * 1000)) ;
    return date.toISOString().split("T")[0];
}
app.config.globalProperties.$getNextMonthStart = ()=>{
    var today = new Date();
    var date = new Date(today.getFullYear(), today.getMonth() + 1, 1, 0, 0, 0, 0);
    date = new Date(date.getTime() - (date.getTimezoneOffset() * 60 * 1000)) ;
    return date.toISOString().split("T")[0];
}
app.config.globalProperties.$getMonthEnd = ()=>{
    var today = new Date();
    var date = new Date(today.getFullYear(), today.getMonth() + 1, 0, 0, 0, 0, 0);
    date = new Date(date.getTime() - (date.getTimezoneOffset() * 60 * 1000)) ;
    return date.toISOString().split("T")[0];
}
app.config.globalProperties.$getEpochStart = ()=>{
    var date = new Date(1970, 0, 1, 0, 0, 0, 0);
    date = new Date(date.getTime() - (date.getTimezoneOffset() * 60 * 1000)) ;
    return date.toISOString().split("T")[0];
}
app.config.globalProperties.$getCurrentDay = ()=>{
    var today = new Date();
    var date = new Date(today.getTime() - (today.getTimezoneOffset() * 60 * 1000) + (24 * 60 * 60 * 1000) ) ;
    return date.toISOString().split("T")[0];
}
//------------------------------------------------ disable-autocomplete
// import DisableAutocomplete from 'vue-disable-autocomplete';
// Vue.use(DisableAutocomplete);
//------------------------------------------------ Mount App
app.mount('#app');
